import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/img/icon/busfull-alert-red.svg'
import _imports_1 from '@/assets/img/icon/passenger-fill-green.svg'


const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { class: "w-2/12" }
const _hoisted_3 = { class: "border-grey-2 rounded-lg" }
const _hoisted_4 = { class: "lg:flex items-center justify-between p-4" }
const _hoisted_5 = { class: "text-xl font-bold" }
const _hoisted_6 = { class: "flex items-center gap-3" }
const _hoisted_7 = { class: "text-grey text-base font-normal" }
const _hoisted_8 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 p-4" }
const _hoisted_9 = { class: "border-grey-2 rounded-xl p-4" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "text-xl font-bold" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-base font-normal" }, "Kapasitas Penuh", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-6",
    alt: "bus-full"
  })
], -1)
const _hoisted_14 = { class: "border-grey-2 rounded-xl p-4" }
const _hoisted_15 = { class: "flex justify-between" }
const _hoisted_16 = { class: "text-xl font-bold" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-grey text-base font-normal" }, "Belum melakukan check in", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-7",
    alt: "bus-full"
  })
], -1)
const _hoisted_19 = { class: "flex flex-wrap px-4 mb-3 gap-4" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "flex items-center justify-between gap-4 background-grey-2 rounded-lg p-2" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Trayek ")
const _hoisted_26 = { class: "text-base font-bold" }
const _hoisted_27 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_28 = {
  key: 0,
  class: "w-3/12"
}
const _hoisted_29 = {
  class: "w-full my-4",
  style: {"height":"150px","max-height":"200px","overflow-y":"auto"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "w-full grid grid-cols-2 gap-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "Nopol"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-center text-grey text-base font-bold" }, "PP")
], -1)
const _hoisted_31 = { class: "text-center text-grey text-base font-normal" }
const _hoisted_32 = { class: "text-center text-grey text-base font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderFilter = _resolveComponent("HeaderFilter")!
  const _component_LeftFilter = _resolveComponent("LeftFilter")!
  const _component_InputIconRight = _resolveComponent("InputIconRight")!
  const _component_TableRoster = _resolveComponent("TableRoster")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Card = _resolveComponent("Card")!
  const _component_InfoConductor = _resolveComponent("InfoConductor")!
  const _component_PariwisataRosterDialog = _resolveComponent("PariwisataRosterDialog")!
  const _component_ChangeStatusForm = _resolveComponent("ChangeStatusForm")!
  const _component_ChangeVehicleForm = _resolveComponent("ChangeVehicleForm")!
  const _component_ChangeStatusActiveForm = _resolveComponent("ChangeStatusActiveForm")!
  const _component_HjpSideBar = _resolveComponent("HjpSideBar")!
  const _component_HjpCofirmModal = _resolveComponent("HjpCofirmModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HeaderFilter, {
      modelValue: _ctx.filterDate,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterDate) = $event)),
      onCheckIsToday: _cache[1] || (_cache[1] = (val) => _ctx.checkIsTodayAct(val))
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_LeftFilter, { isRoster: true })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(!_ctx.isEmpty(_ctx.selectedConductor) ? 'w-7/12' : 'w-10/12')
      }, [
        _createVNode(_component_Card, { class: "card-no-shadow wrap-hjp-data-table" }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.moment(_ctx.filterDate).format('DD MMMM YYYY')), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(`Last Updated : ${_ctx.lastUpdate.format('DD MMMM YYYY')}, at ${_ctx.lastUpdate.format('HH.mm')}`), 1),
                    _createElementVNode("i", {
                      class: "pi pi-sync text-primary text-xs font-normal cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.refreshPage && _ctx.refreshPage(...args)))
                    })
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_InputIconRight, {
                    class: "input-search-header-custom",
                    placeholder: _ctx.placeholder,
                    modelValue: _ctx.inputSearch,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputSearch) = $event)),
                    canClick: Boolean(_ctx.selectedTrayek),
                    icon: _ctx.icon.svg.searchEva,
                    onSubmitInput: _ctx.onSearch,
                    onKeyup: _withKeys(_ctx.onSearch, ["enter"]),
                    disabled: !Boolean(_ctx.selectedTrayek)
                  }, null, 8, ["placeholder", "modelValue", "canClick", "icon", "onSubmitInput", "onKeyup", "disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(`${_ctx.dataRosterPreview?.RosterFullyBooked ?? '0'} Bus`), 1),
                      _hoisted_12
                    ]),
                    _hoisted_13
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(`${_ctx.dataRosterPreview?.RosterHaventCheckin ?? '0'} Penumpang`), 1),
                      _hoisted_17
                    ]),
                    _hoisted_18
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFilterTrayek, (trayek, tIdx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tIdx,
                      class: "chip-primary flex text-xs items-center gap-2"
                    }, [
                      _createTextVNode(_toDisplayString(trayek.label) + " ", 1),
                      _createElementVNode("i", {
                        class: "pi pi-times cursor-pointer text-xs",
                        onClick: ($event: any) => (_ctx.store.dispatch(`${_ctx.module}/deleteFilterTrayek`, trayek))
                      }, null, 8, _hoisted_20)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFilterClass, (val, cIdx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: cIdx,
                      class: "chip-primary flex text-xs items-center gap-2"
                    }, [
                      _createTextVNode(_toDisplayString(val.label) + " ", 1),
                      _createElementVNode("i", {
                        class: "pi pi-times cursor-pointer text-xs",
                        onClick: ($event: any) => (_ctx.store.dispatch(`${_ctx.module}/deleteFilterClass`, val))
                      }, null, 8, _hoisted_21)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFilterTol, (val, tIdx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tIdx,
                      class: "chip-primary flex text-xs items-center gap-2"
                    }, [
                      _createTextVNode(_toDisplayString(val.label) + " ", 1),
                      _createElementVNode("i", {
                        class: "pi pi-times cursor-pointer text-xs",
                        onClick: ($event: any) => (_ctx.store.dispatch(`${_ctx.module}/deleteFilterTol`, val))
                      }, null, 8, _hoisted_22)
                    ]))
                  }), 128))
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trayekList, (data, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "px-4 mb-4",
                  key: idx
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: "cursor-pointer",
                      onClick: ($event: any) => (_ctx.getPlottingDetail(data.Id))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.selectedTrayek === data.Id ? 'pi pi-angle-right mr-3' : 'pi pi-angle-down mr-3')
                      }, null, 2),
                      _hoisted_25,
                      _createElementVNode("span", _hoisted_26, _toDisplayString(`${data.MsClass.Name} | ${data.IsTol ? 'Tol' : 'Non Tol'} |`), 1),
                      _createTextVNode(" " + _toDisplayString(data.Name), 1)
                    ], 8, _hoisted_24)
                  ]),
                  (_ctx.selectedTrayek === data.Id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createVNode(_component_TableRoster, _mergeProps({
                          "plotting-list": _ctx.plottingList,
                          isRoster: true
                        }, _ctx.plottingTableProp, {
                          onChangePage: _ctx.nextPagePlotting,
                          isEdit: true,
                          onSubmit: _ctx.onSubmitPlotting,
                          dateFilter: _ctx.filterDate,
                          onOnDeactiveRoster: _ctx.onDeactiveRosterAction,
                          onOnChangeStatusRoster: _ctx.onChangeStatusRosterAction,
                          onOnChangeVehicleRoster: _ctx.onChangeVehicleRosterAction,
                          onOnChangeStatusActiveRoster: _ctx.onChangeStatusActiveRosterAction
                        }), null, 16, ["plotting-list", "onChangePage", "onSubmit", "dateFilter", "onOnDeactiveRoster", "onOnChangeStatusRoster", "onOnChangeVehicleRoster", "onOnChangeStatusActiveRoster"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_ctx.paginate.totalRecords > 0)
                ? (_openBlock(), _createBlock(_component_Paginator, {
                    key: 0,
                    rows: _ctx.paginate.pageSize,
                    totalRecords: _ctx.paginate.totalRecords,
                    onOnPage: _ctx.onChangePage
                  }, null, 8, ["rows", "totalRecords", "onOnPage"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ], 2),
      (!_ctx.isEmpty(_ctx.selectedConductor))
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createVNode(_component_InfoConductor)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.store.state?.headerButton.isShowDialogForm)
      ? (_openBlock(), _createBlock(_component_PariwisataRosterDialog, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_HjpSideBar, {
      show: _ctx.showModalForm,
      onHideDialog: _ctx.hideModalForm,
      canDelete: false
    }, _createSlots({ _: 2 }, [
      (_ctx.showModalForm)
        ? {
            name: "form",
            fn: _withCtx(() => [
              (_ctx.sidebarFormState === 0)
                ? (_openBlock(), _createBlock(_component_ChangeStatusForm, {
                    key: 0,
                    onShowConfirmDialog: _ctx.showConfirmDialog
                  }, null, 8, ["onShowConfirmDialog"]))
                : _createCommentVNode("", true),
              (_ctx.sidebarFormState === 1)
                ? (_openBlock(), _createBlock(_component_ChangeVehicleForm, {
                    key: 1,
                    onReloadData: _ctx.reloadFromVehicle
                  }, null, 8, ["onReloadData"]))
                : _createCommentVNode("", true),
              (_ctx.sidebarFormState === 2)
                ? (_openBlock(), _createBlock(_component_ChangeStatusActiveForm, {
                    key: 2,
                    onShowConfirmDialog: _ctx.onDeactiveRosterAction
                  }, null, 8, ["onShowConfirmDialog"]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1032, ["show", "onHideDialog"]),
    _createVNode(_component_HjpCofirmModal, {
      show: _ctx.modalConfirmation.show,
      title: _ctx.modalConfirmation.title,
      subTitle: _ctx.modalConfirmation.subTitle,
      subTitleHtml: _ctx.modalConfirmation.subTitleHtml,
      btnSubmitTitle: _ctx.modalConfirmation.btnSubmitTitle,
      imgContent: _ctx.modalConfirmation.imgContent,
      onHideDialog: _ctx.hideConfirmDialog,
      onOnSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isEdit ? _ctx.progressSubmitPlotting() : _ctx.submitFromDialog()))
    }, _createSlots({ _: 2 }, [
      (_ctx.currentKondekturRoster.length > 0)
        ? {
            name: "additionalContent",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentKondekturRoster, (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data,
                    class: "w-full grid grid-cols-2 gap-2 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(data.nopol), 1),
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.pps, (item) => {
                        return (_openBlock(), _createElementBlock("div", { key: item }, [
                          _createElementVNode("p", _hoisted_32, _toDisplayString(`PP${item.order} (${item.time})`), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ])
            ])
          }
        : undefined
    ]), 1032, ["show", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "imgContent", "onHideDialog"])
  ]))
}